const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        abschluss: 'Abschluss',
        eCheckinCompletion:
            'Mit Abschluss des eCheckin akzeptiere ich die allgemeinen Geschäftsbedingungen (AGB) der ' +
            'Solothurner Spitäler AG sowie die Direktabrechnung mit meinem Versicherer und die damit ' +
            'verbundene elektronische Deckungsabfrage.',
        insuranceInfo:
            'Sie haben Zusatzversicherungsleistungen  und bestätigen hiermit die Übernahme der Kosten bei ' +
            'einer allfälligen Unterdeckung oder eines Ausschlusses. Details entnehmen Sie aus dem ' +
            'Informationsschreiben.\n' +
            'Wenn Sie dies nicht wünschen, muss die Versicherungsdeckung unter der Rubrik Versicherungsangabe ' +
            'angepasst werden auf Allgemein.',
        termsAndConditions: 'Allgemeine Geschäftsbedingungen',
        abschlussInfoText:
            'Bei Rückfragen vor dem Abschluss des eCheckin unterstüzen wir Sie gerne:\nUnser Support steht Ihnen ' +
            'von Montag bis Freitag \nvon 07:00 bis 12:00 Uhr und 13:00 bis 16:00 Uhr zur Verfügung.\n' +
            'Telefonisch +41 32 627 30 42 oder \nper E-Mail meinesoh@spital.so.ch\n',
        arbeitgeber: 'Berufstätigkeit',
        employment: 'Ich bin',
        arbeitgeberCompany: 'Firma',
        streetAndNumber: 'Strasse und Nr.',
        country: 'Land',
        tel: 'Telefon',
        employed: 'Angestellt',
        unemployedRAV: 'Stellenlos RAV',
        notEmployed: 'Nicht berufstätig',
        selfEmployed: 'Selbstständig',
        hausArzt: 'Hausarzt',
        keinHausarzt: 'Ich habe keinen Hausarzt',
        refferedDoctor: 'Durch welchen Arzt erfolgte die Zuweisung ins Spital?',
        firstname: 'Vorname',
        lastname: 'Nachname',
        hausArztInfoText: 'Erfassung Ihrer Arzt Zuständigkeiten ausserhalb der Solothurner Spitäler AG',
        versicherungUndZusatzleistung: 'Versicherung und Zusatzleistung',
        insuranceInfoText:
            'Als unsere Patientin, unser Patient sind Sie auch unser \nGast und stehen somit im Zentrum unseres ' +
            'Handelns. Damit Sie sich rundum wohl fühlen, einen angenehmen Aufenthalt verbringen und rasch gesund ' +
            'werden, erhalten Sie einen massgeschneiderten Service.\n',
        reasonForTreatment: 'Behandlungs­grund',
        insurance: 'Versicherung',
        accidentDate: 'Unfalldatum',
        unfallGemeldet: 'Unfall gemeldet?',
        schadennummer: 'Schaden­nummer',
        nameDerVersicherung: 'Name der Versicherung',
        workStatus: 'Ich bin...',
        employer: 'Arbeitgeber',
        employerCountry: 'Arbeitgeber-Land',
        accidentReport:
            'Den Unfall habe ich meinem Arbeitgeber/RAV gemeldet. (Wenn nein, Kosten zu Lasten des Patienten)',
        claimNum: 'Schadennummer',
        employerReport:
            'Den Unfall habe ich meinem Arbeitgeber/RAV gemeldet.\n(Wenn nein, Kosten zu Lasten des Patienten)',
        insuranceEmployer: 'Arbeitgeber',
        maternityPacket: 'Ich möchte das kostenpflichtig Geburtspacket buchen.',
        insuranceInformation: 'Versicherungs­angabe',
        insuranceCoverage: 'Versicherungs­deckung',
        diffZusatzversicherung: 'Zusatzversicherung (VVg) bei der gleichen Krankenkasse',
        hasZusatzversicherung: 'Ich habe eine Zusatzversicherung (VVg)',
        mitglied: 'ich bin Mitglied im Spital Club',
        insuranceNumber: 'Versicherungs­nummer',
        nsNumber: 'N/S Nummer',
        cardNumber: 'Karten Nr.',
        directBillingText:
            'Ich bin mit der Direktabrechnung mit meinem Versicherer und der damit verbundenen elektronischen ' +
            'Deckungsabfrage einverstanden:',
        additionalServicesInsurance:
            'Ich möchte bei einem Spitalaufenthalt (Flex-/Wahl-Versicherungen) folgende Zusatzleistungen in ' +
            'Anspruch nehmen.',
        additionalInsuranceVVGText:
            'Ich habe meine Zusatz­versicherung (VVG) bei der gleichen Krankenkasse wie die Grundversicherung (OKP) ',
        additionalInsuranceVVG: 'Zusatz­versicherung (VVG)',
        additionalInsurance: 'Zusatz­versicherung',
        insuranceNumberZV: 'Versicherten­nummer ZV',
        moreInformation: 'Weitere Angaben zur Versicherung ',
        medicalDataText:
            'Ihre medizinischen Daten werden verschlüsselt und Datenschutzkonform an Ihre Versicherung zugestellt. \nSind Sie damit einverstanden?',
        medicalData: 'Sind Sie einverstanden?',
        directBilling: 'Direktabrechung',
        singleRoomBooking: 'Ich möchte ein Einzelzimmer kostenpflichtig buchen.',
        additionalInsuranceBenefitsText:
            'Sie haben Zusatzversicherungsleistungen  und bestätigen hiermit die Übernahme der Kosten bei einer ' +
            'allfälligen Unterdeckung oder eines Ausschlusses. Details entnehmen Sie aus dem ' +
            'Informationsschreiben.\nWenn Sie dies nicht wünschen, muss die Versicherungsdeckung unter der Rubrik ' +
            'Versicherungsangabe angepasst werden auf Allgemein.',
        additionalInsuranceBenefits: 'Zusatzversiche­rungsleistungen',
        socialNumber: 'Sozialversiche­rung Nr',
        broschure: 'Gemäss Broschüre wünsche ich weitere Zusatzleistungen, bitte nehmen Sie mit mir KontaktPerson auf.',
        burgerspitalSolothurn: 'Bürgerspital Solothurn',
        kantonsspitalOlten: 'Kantonsspital Olten',
        spitalClub: 'Spitalclub',
        broschureMaternity: 'Geburtspackage',
        accidentInsurance: 'Unfallversicherung',
        bezEhepartner: 'Ehepartner',
        bezElternteil: 'Elternteil',
        bezGeschwister: 'Geschwister',
        bezLebenspartner: 'Lebenspartner',
        kontakt: 'Kontaktperson',
        keineAngaben: 'Ich möchte keine Angaben zu Angehörigen machen',
        beziehung: 'Beziehung',
        secndBeziehung: '2. Beziehung',
        priorityContact: 'Gesetzlicher Vertreter',
        persAngaben: 'Persönliche Angaben',
        dateOfBirth: 'Geburtstag',
        gender: 'Geschlecht',
        zivilstand: 'Zivilstand',
        language: 'Gewünschte Korrespondenz­sprache',
        requestedLanguage: 'Sprache',
        nationality: 'Nationalität',
        profession: 'Beruf',
        religion: 'Religion',
        pfarramt: 'Bei Anfragen des Pfarramts/der Seelsorger wünsche ich die Informationsweitergabe',
        zivilWohnsitz: 'Abweichender zivilrechtlicher Wohnsitz',
        zivilWohnsitzAdress: 'Zivil­rechtlicher Wohnsitz',
        korres: 'Abweichende Korrespon­denzadresse',
        korresAdresse: 'Korrespondenz­adresse',
        electrRadiologieBilder: 'Elektr. Radiologiebilder',
        smsReminder: 'SMS Reminder',
        infoText: 'Erfassung Ihrer persönlichen Angaben gemäss Pass/ID oder Schweizer Niederlassungsbewilligung',
        mobile: 'Telefon Mobile',
        welcome: 'Willkommen',
        CHWohnort: 'Wohnort / Ver­sicherung.',
        sozialversicherungsnr: 'Sozialversicherungsnummer',
        cardnr: 'Karten Nr.',
        expirydate: 'Ablauf­datum',
        versicherungName: 'Ver­sicherung',
        yes: 'Ja',
        no: 'Nein',
        direktabrechnung: 'Direktabrechung',
        direktabrechnung1:
            'Ich bin mit der Direktabrechnung mit meinem Versicherer und der damit verbundenen elektronischen ' +
            'Deckungsabfrage einverstanden:',
        zuweisenderArzt: 'Zuweisender Arzt',
        zuweisenderArztKeinHausarzt: 'Ich habe keinen Hausarzt',
        zuweisenderArztInfoText: 'Erfassung ihrer Arzt Zuständigkeiten ausserhalb der Solothurner Spitäler AG.',
        zuweisenderArztRefferedDoctor: 'Durch welchen Arzt erfolgte die Zuweisung ins Spital?',
        zuweisenderArztFirstname: 'Vorname',
        zuweisenderArztLastname: 'Nachname',
        brosureLabel: 'Gemäss Broschüre wünsche ich weitere Zusatzleistungen, bitte nehmen Sie mit mir Kontakt auf.',
    },
    __RELATIVE_SOURCE_FILE__
);
